// extracted by mini-css-extract-plugin
module.exports = {"advertisementText":"styles_advertisementText__uLlsr","left":"styles_left__qTrvg","right":"styles_right__Fw4eB"};